import { useState, useCallback } from 'react';

interface UseDietaryRestrictionsProps {
  selected: string[];
  onToggle: (restriction: string) => void;
  onAddCustom: (restriction: string) => boolean;
  onRemoveCustom: (restriction: string) => void;
}

export const useDietaryRestrictions = ({
  selected,
  onToggle,
  onAddCustom,
  onRemoveCustom,
}: UseDietaryRestrictionsProps) => {
  const [customInput, setCustomInputState] = useState('');

  const handleToggle = useCallback(
    (restriction: string) => {
      onToggle(restriction);
    },
    [onToggle]
  );

  const handleInputChange = useCallback((value: string) => {
    // Prevent commas from being entered
    setCustomInputState(value.replace(/,/g, ''));
  }, []);

  const handleAddCustom = useCallback(() => {
    const trimmed = customInput.trim();
    if (trimmed && !trimmed.includes(',')) {
      const success = onAddCustom(trimmed);
      if (success) {
        setCustomInputState('');
      }
    }
  }, [customInput, onAddCustom]);

  const handleRemoveCustom = useCallback(
    (restriction: string) => {
      onRemoveCustom(restriction);
    },
    [onRemoveCustom]
  );

  const handleKeyPress = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        handleAddCustom();
      }
    },
    [handleAddCustom]
  );

  return {
    customInput,
    setCustomInput: handleInputChange,
    handleToggle,
    handleAddCustom,
    handleRemoveCustom,
    handleKeyPress,
  };
};

